import React from "react";
import { colors, fonts, space } from "../theme";

/**
 * The Alvna brand block. Always sits at the top — of the sidebar on the
 * customer/admin app, and above the login form on the login page.
 *
 * variant="full"  -> logo + tagline + optional business name (sidebar, main login)
 * variant="compact" -> smaller "Powered by Alvna" mark (waiter/kitchen login)
 */
export default function AlvnaBrand({ variant = "full", businessName, dark = false }) {
  if (variant === "compact") {
    return (
      <div style={styles.compactWrap}>
        <img src="/alvna-logo.png" alt="Alvna" style={styles.compactLogo} />
        <span style={styles.compactText}>Powered by Alvna</span>
      </div>
    );
  }

  return (
    <div style={{ ...styles.wrap, borderBottom: `1px solid ${dark ? colors.darkBorder : colors.border}` }}>
      <img src="/alvna-logo.png" alt="Alvna" style={styles.logo} />
      <div style={{ ...styles.tagline, color: dark ? colors.textMuted : colors.textSecondary }}>
        Powered by Alvna Digital
      </div>
      {businessName && (
        <div style={{ ...styles.businessName, color: dark ? colors.darkText : colors.textPrimary }}>
          {businessName}
        </div>
      )}
    </div>
  );
}

const styles = {
  wrap: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: `${space[6]} ${space[4]} ${space[4]}`,
    borderBottom: `1px solid ${colors.border}`,
  },
  logo: { width: 140, height: "auto", marginBottom: space[2] },
  tagline: {
    fontFamily: fonts.body,
    fontSize: 11,
    color: colors.textSecondary,
    letterSpacing: "0.03em",
    textTransform: "uppercase",
  },
  businessName: {
    marginTop: space[3],
    fontFamily: fonts.display,
    fontSize: 15,
    fontWeight: 600,
    color: colors.textPrimary,
    textAlign: "center",
  },
  compactWrap: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: space[2],
    opacity: 0.92,
  },
  compactLogo: { width: 30, height: "auto" },
  compactText: {
    fontFamily: fonts.body,
    fontSize: 14,
    fontWeight: 500,
    color: colors.textSecondary,
    letterSpacing: "0.01em",
  },
};
